import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_BG.json';
import exercises from './FITNESS_EXERCISES_BG.json';
import recipes from './FITNESS_RECIPES_BG.json';

export const FITNESS_DATA_BG: ServiceData = {
  articles,
  exercises,
  recipes,
};
